import { AuthenticationLegacyConfig } from '@afe/authentication/legacy';
import { urlConfig } from './url.config';

export const legacyAuthConfig: AuthenticationLegacyConfig = {
  urlsToIntercept: [urlConfig.base.urlApigee],
  urlLogin: urlConfig.auth.urlLogin,
  urlLogout: urlConfig.auth.urlLogout,
  clientId: urlConfig.auth.cliendId,
  appKey: urlConfig.auth.ApigeeAppKey,
  zupAppKey: urlConfig.auth.zupAppKey,

  urlsToIgnore: [],
};
